import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { NotificationsAppIntentBody } from "./NotificationsAppIntentBody";
import { AnimatePresence, motion } from "framer-motion";
import { useAuthStore } from "@um/ui";

interface NotificationsAppIntentProps {
  hidden: boolean;
  character?: {
    name?: string;
    avatarUrl?: string;
  };
}

export const NotificationsAppIntentDialog: React.FC<
  NotificationsAppIntentProps
> = ({ character, hidden = false }) => {
  const { settings, user } = useAuthStore();
  const location = useLocation();

  const [hideDialog, setHideDialog] = useState(hidden);

  // Don't show during onboarding or template view - they have their own flows
  const isExcludedRoute =
    location.pathname === "/onboarding" ||
    location.pathname.startsWith("/dev/") ||
    location.pathname.startsWith("/view");

  const open =
    !isExcludedRoute &&
    user?.isAnonymous === false &&
    settings.createdDefaultCharacter &&
    (!settings.acknowledgedNotifications ||
      !settings.acknowledgedSupportingPerson);

  return (
    <AnimatePresence>
      {open && !hideDialog && (
        <div className="fixed inset-0 z-50 flex min-h-0 items-center justify-center p-safe">
          <motion.div
            className="absolute inset-0 bg-black/30 backdrop-blur-sm"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2, ease: "easeOut" }}
          />

          <motion.div
            className="relative z-10 flex max-h-full min-h-0 w-full max-w-md flex-col overflow-hidden"
            role="dialog"
            aria-modal="true"
            initial={{ opacity: 0, y: 24, scale: 0.96 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 24, scale: 0.96 }}
            transition={{
              type: "spring",
              stiffness: 260,
              damping: 20,
              mass: 0.6,
            }}
          >
            <div className="relative min-h-0 m-4 flex-1 overflow-y-auto overscroll-contain rounded-xl border border-black/5 bg-white/95 shadow-2xl backdrop-blur-sm">
              <NotificationsAppIntentBody
                character={character}
                setHideDialog={setHideDialog}
              />
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};
